<template>
    <div>
        <div class="page-group-title"><span><span class="el-icon-collection-tag"></span> {{label}}</span></div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="实际含义" :value="1"></el-option>
                            <el-option label="值ID" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div v-if="$utils.have('/label/value/edit')" class="page-btns-box">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="$refs.add.show()">增加取值</el-button>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column prop="id" label="值ID">
                </el-table-column>
                <el-table-column prop="symbol" label="代表符号">
                </el-table-column>
                <el-table-column prop="actualMeaning" label="实际含义" show-overflow-tooltip>
                </el-table-column>
				<el-table-column prop="boundaryValue" label="判断值" show-overflow-tooltip>
				</el-table-column>
                <el-table-column prop="createTime" label="创建时间" min-width="150">
                </el-table-column>
                <el-table-column prop="modifyTime" label="最近修改" min-width="150">
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button v-if="$utils.have('/label/value/edit')" type="text" size="small"
                            @click="$refs.add.show(scope.row.id)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <add-value ref="add" @onUpdate="getDataList" :labelId="id" :label="label"></add-value>
    </div>
</template>

<script>
import AddValue from './components/AddValue.vue'
const defaultParams = {
    pageNo: 1,
    labelId: "",
    searchType: 1, //1：实际含义 2：id	
    searchValue: "",
}
export default {
    components: { AddValue },
    props:{
        id: {
            type: [String,Number],
            default: ""
        }
    },
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || '',
            },
            listLoading: true,
            label: ""
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.params = {
                ...this.params,
                labelId: this.id,
            }
            this.$request({
                url: "/label/value/list",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        if( this.params.pageNo == 1 ){
                            if( result.object ){
                                this.label = result.object + ' - '
                            }
                            if( result.secondLevel ){
                                this.label += result.secondLevel + ' - '
                            }
                            if( result.secondLevel ){
                                this.label += result.secondLevel + ' - '
                            }
                            if( result.labelName ){
                                this.label += result.labelName
                            }
                        }
                        this.data = result.valueListPage;
                        this.dataList = this.data.result || [];
                    } else {
                        this.data = null;
                        this.dataList = [];
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
    }
}
</script>
<style lang="scss" scoped>

</style>